import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { RequestResultSettingDto } from "../models/request-result-settings/request-result-setting.dto";
import { RequestResultSettingListItem } from "../models/request-result-settings/request-result-setting-list-item";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../core/services/notification.service";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { KeyValueObject } from "../models/core/KeyValueObject";

@Injectable()
export class RequestResultSettingsService extends DataService<RequestResultSettingListItem, RequestResultSettingDto> {

    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'request-result-settings';
    }

    public getByRequest(requestTypeId: number, clientId: number): Observable<KeyValueObject[]> {
        const url = `${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/by-request?requestTypeId=${requestTypeId}${clientId != null ? '&clientId=' + clientId : ''}`;
        return this.getQuery<KeyValueObject[]>(url);
    }

    public saveRequestResult(requestId: number, requestResultId: number): Observable<any> {
        const url = `${environment.apiUrl}v${this.controllerVersion}/${this.controllerName}/save-request-result`;
        return this.postQuery(url, { requestId, requestResultId });
    }
}
